import React from 'react'
import { Link } from 'react-router-dom'
import MessageUI from '../widgets/output/MessageUI'
import ThemeSF from '../components/common/ThemeSF'
import './HeaderRight.css'

const PrivateHeaderRightUI = ({context, messageList}) =>
  <div className='t_hdr_rgt g_flex_h'>
    {
      context.session.appCode === 'finapp' &&
      <React.Fragment>
        <Link className='link' to='/home'>
          <MessageUI messageList={messageList} messageKey='c_home' />
        </Link>
        {/*
        <Link className='link' to='/support/chat'>Chat</Link>
        <Link className='link' to='/support/openai'>Open AI</Link>
        <Link className='link' to='/reports'>
          <MessageUI messageList={messageList} messageKey='c_reports' />
        </Link>
        <Link className='link' to='/alerts'>
          <MessageUI messageList={messageList} messageKey='c_alerts' />
        </Link>
        */}
      </React.Fragment>
    }
    {
      context.session.appCode === 'projectapp' &&
      <React.Fragment>
        <Link className='link' to='/projects'>
          <MessageUI messageList={messageList} messageKey='c_projects' />
        </Link>
      </React.Fragment>
    }
    <Link className='link' to='/settings'>
      <MessageUI messageList={messageList} messageKey='c_settings' />
    </Link>
    <ThemeSF context={context} />
  </div>

export default PrivateHeaderRightUI
